/**
 * Who may flip Project Lock: the show's owner, always.
 *
 * Josh, 10 Oct 2026. The switch used to be disabled unless the owner had a paid plan
 * (user.active_pay). That was wrong twice over: editing is paid PER PERSON
 * (canEditActiveProject), so collaborators keep working after an owner lapses and the
 * owner could no longer lock (or unlock) the show under them; and an owner whose show
 * carries a Show Pass (project.unlocked) but no subscription was blocked too.
 * Administrators do not get the switch; that is unchanged. Firestore rules do not
 * gate `locked`, so this is the whole check.
 *
 * @param {{ uid?: string }|null|undefined} user
 * @param {{ ownerUID?: string }|null|undefined} project
 * @returns {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
export function canToggleProjectLock(user, project) {
    return !!(user && user.uid && project && project.ownerUID === user.uid);
}


// WEBPACK FOOTER //
// ./src/lib/project-lock.js